<template>
  <div class="container boxShadow">
    <h5>市南区文化馆场馆预约须知</h5>
    <div class="cont">
      <p>一、使用场馆需提前一周登录市南区文化馆网站进行预约；</p>
      <p>二、必须是市南区群众艺术团体人数为5-25人。为了有效服务更多的群众，团队预约每周仅可以预约一个时间段，重复预约视为无效。</p>
      <p>三、请按照预约流程如实提供预约人及团队成员的身份证相关信息，在预约或教室使用过程中，一但发现预约人及成员有信息造假或者预约信息瞒报行为，立即取消预约和使用资格；</p>
      <p>四、场地使用时如需要播放音乐，请将音量调到合适位置，不得干扰到馆内其他教室内的活动；</p>
      <p>五、如需使用场馆内的相关排练设备，请咨询工作人员，切勿自行操作；</p>
      <p>六、请保持场馆内良好环境和风气，禁止在场馆内饮酒、吸烟、吐痰、乱扔杂物、吃东西，禁止在场馆内进行争吵、辱骂、打架、斗殴等不良行为；</p>
      <p>七、不得在场馆内进行产品推销及其他商业活动，不得在场馆内从事传销等非法活动；</p>
      <p>八、禁止酒后或患高血压、心脏病、癫痫等危险易急性发病者和身体不适者进入，后果自负；</p>
      <p>九、如未遵守本须知，造成不良后果的，责任自负；因人为损坏设施设备的，需要照价赔偿；</p>
      <p>十、请保管好随身携带的贵重物品，如有丢失概不负责；</p>
      <p>十一、请勿携带宠物进入教室；</p>
      <p>十二、各团队请文明使用场馆，场馆内与人接触请保持良好素质，如若在场馆预约或使用方面有争议情况请联系馆内工作人员；</p>
      <p>十三、参加活动人员要积极配合工作人员的管理，自觉遵守各场馆教室的使用时间，按规定时间进出教室，谢谢合作！</p>
    </div>
    <div class="btn btn-primary" @click="linkTo">阅读并同意</div>
  </div>
</template>
    
    <script>
export default {
  props: {

  },
  data() {
    return {

    };
  },
  computed: {

  },
  created() {

  },
  mounted() {

  },
  watch: {

  },
  methods: {
    linkTo() {
      let target = this.$route.query.target
      if (target == 'course') {
        this.$router.replace({
          path: '/protocol',
          query: {
            id: this.$route.query.id
          }
        })
      } else {
        this.$router.replace({
          path: '/orderInfo',
          query: {
            id: this.$route.query.id
          }
        })
      }
    }
  },
  components: {

  },
};
    </script>
    
    <style scoped>
.container {
  background: #fff;
  padding: 50px;
}

.container > h5 {
  font-size: 1.3em;
  color: #333333;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
}

.cont {
  padding: 15px 0;
}

.cont p {
  text-indent: 2em;
  font-size: 1em;
  color: #333;
  line-height: 2;
}
@media only screen and (max-width: 750px) {
  .container > h5 {
    font-size: 1em;
    padding-bottom: 0.1rem;
  }
  .cont .item {
    width: 100%;
  }
  .container {
    padding: 0.15rem;
    font-size: 0.14rem;
  }
}
</style>